module.exports = __webpack_public_path__ + "media/virtualStagingSlider/virtualStagingSlider8Pre-ac724e2e.jpeg";